import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./components/Application/App";
import reportWebVitals from "./reportWebVitals";
import { getURLPathArray, getURLSearchParam } from "./lib/iprs-react-library/src/index.js";
import { BrowserRouter as Router } from "react-router-dom";

import API from "iprs-api-library";

const apiURL = process.env.REACT_APP_IPRS_WEB_API_URL;
const api = new API(null, apiURL);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Router>
        <App
            getURLSearchParam={getURLSearchParam}
            api={api}
            getURLPathArray={getURLPathArray}
        />
    </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
